import { useTranslation } from "react-i18next";
import "../../styles/mapStyles/SearchModeToggle.css";

// ─────────────────────────────────────────────
// SearchModeToggle
// A toggle component for switching between
// location and GPS search modes. Uses icons
// to represent each mode.
//
// Props:
// - searchMode: current mode ("location" or "gps")
// - onToggle: function to call when toggling
// ─────────────────────────────────────────────

function SearchModeToggle({ searchMode, onToggle }) {
  const { t } = useTranslation();
  return (
    <div className="search-mode-toggle">
      <button
        type="button"
        className={`toggle-btn ${searchMode === "location" ? "active" : ""}`}
        onClick={() => onToggle("location")}
        title={t("search.searchByLocation")}
      >
        {t("common.location")}
      </button>
      <button
        type="button"
        className={`toggle-btn ${searchMode === "gps" ? "active" : ""}`}
        onClick={() => onToggle("gps")}
        title={t("search.searchByGps")}
      >
        {t("common.gps")}
      </button>
    </div>
  );
}

export default SearchModeToggle;